/**
 * generationMessages.js — F-334/F-335. The two things we say when a story does not get written.
 *
 * WORD-GATED. Both strings below were approved VERBATIM by the founder in F-334 item 3. Do not
 * reword, retitle, or "tighten" either one without a new word-gate.
 *
 * EM-DASH CONFLICT, RESOLVED (F-336 ruling 1, option c): the first approved wording carried an
 * em-dash ("on this screen — please"), which the brand rule bars in customer-facing copy. The founder
 * ruled SPLIT rather than substitute-a-comma, so it is two sentences. Re-approved verbatim.
 *
 * They render as a PERSISTENT INLINE BANNER on the conversation screen, never as the 4s toast:
 * the toast erased its own explanation four seconds after the only thing the teller was ever told
 * ([V-333] obs 2), and at 390px it sat on top of the input box ([V-333] obs 3).
 */

/** Any generation that failed: pair_timeout, assembler_fail, empty_output. */
export const GENERATION_FAILED_MESSAGE =
  "Something went wrong and your story wasn't written. Your words are still here on this screen. Please don't close this page. Tap Finish my story to try again.";

/**
 * The substance floor REFUSED to write this one. Not a delay and not a failure: Pip needs more to
 * work with. Until F-334 this shared the stall string, so a refusal was reported as a delay
 * ([V-333] obs 1, App.js substance-floor block).
 */
export const GENERATION_TOO_THIN_MESSAGE =
  'Pip needs a little more to write this one. Tell Pip another detail or two, then tap Finish my story again.';
